<template>
  <div id="page-user-list">

    <div class="flex flex-wrap items-center">
      <div class="flex-grow">

        <!-- ===================== ค้นหา ===================== -->
        <vx-card class="mb-base">
          <div class="vx-card__title">
            <h4>ค้นหาข้อมูลแนะนำเพื่อน</h4>
            <p class="text-sm mt-1 opacity-75">เลือกช่วงวันที่และ Username AFF เพื่อดูรายงาน</p>
          </div>

          <div class="vx-row mt-4">
            <div class="vx-col w-full md:w-1/4 mb-4">
              <label class="vs-input--label">วันที่เริ่มต้น</label>
              <flat-pickr :config="configDatePicker" v-model="start_date" placeholder="เลือกวันที่" class="w-full" />
            </div>

            <div class="vx-col w-full md:w-1/4 mb-4">
              <label class="vs-input--label">วันที่สิ้นสุด</label>
              <flat-pickr :config="configDatePicker" v-model="end_date" placeholder="เลือกวันที่" class="w-full" />
            </div>

            <div class="vx-col w-full md:w-1/4 mb-4">
              <label class="vs-input--label">Username AFF</label>
              <vs-input v-model="aff_username" placeholder="กรอก Username AFF" class="w-full"
                @keyup.enter="searchData()" />
            </div>

            <div class="vx-col w-full md:w-1/4 mb-4">
              <label class="vs-input--label block">&nbsp;</label>
              <vs-button color="primary" class="w-full" icon-pack="feather" icon="icon-search"
                :disabled="isLoading" @click="searchData()">
                {{ isLoading ? 'กำลังค้นหา...' : 'ค้นหา' }}
              </vs-button>
            </div>
          </div>
        </vx-card>

        <!-- ===================== Summary cards ===================== -->
        <div class="vx-row" v-if="detailData.length > 0">
          <div class="vx-col w-full sm:w-1/2 lg:w-1/4">
            <statistics-card-line hideChart class="mb-base" icon="UsersIcon" icon-right
              :statistic="summary.totalMembers" statisticTitle="ยูสที่ถูกแนะนำทั้งหมด" color="primary" />
          </div>
          <div class="vx-col w-full sm:w-1/2 lg:w-1/4">
            <statistics-card-line hideChart class="mb-base" icon="CheckCircleIcon" icon-right
              :statistic="summary.depositedMembers" statisticTitle="เติมเงินแล้ว" color="success" />
          </div>
          <div class="vx-col w-full sm:w-1/2 lg:w-1/4">
            <statistics-card-line hideChart class="mb-base" icon="TrendingUpIcon" icon-right
              :statistic="formatMoneyZero(summary.totalDeposit)" statisticTitle="ยอดเติมเงินรวม (บาท)" color="success" />
          </div>
          <div class="vx-col w-full sm:w-1/2 lg:w-1/4">
            <statistics-card-line hideChart class="mb-base" icon="TrendingDownIcon" icon-right
              :statistic="formatMoneyZero(summary.totalWithdraw)" statisticTitle="ยอดถอนเงินรวม (บาท)" color="danger" />
          </div>
        </div>

        <!-- ===================== ยอดรวมรายวัน ===================== -->
        <vx-card class="mb-base" v-if="detailData.length > 0">
          <div class="vx-card__title">
            <h4>ยอดรวมรายวัน</h4>
            <br>
          </div>

          <vs-prompt title="Export To Excel (รายวัน)" class="export-options" @cancle="clearFieldsDaily"
            @accept="exportDailyToExcel" accept-text="Export" @close="clearFieldsDaily"
            :active.sync="activePromptDaily">
            <vs-input v-model="fileNameDaily" placeholder="Enter File Name.." class="w-full" />
            <v-select v-model="selectedFormat" :options="formats" class="my-4" />
            <div class="flex">
              <span class="mr-4">Cell Auto Width:</span>
              <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
            </div>
          </vs-prompt>

          <!-- ฟิลเตอร์แบบแฮชแท็ก -->
          <div class="flex flex-wrap items-center mb-4">
            <button v-for="f in dailyFilters" :key="f.key" type="button" class="daily-chip"
              :class="{ 'daily-chip--active': dailyFilter === f.key }"
              @click="dailyFilter = f.key">
              # {{ f.label }} ({{ dailyFilterCount(f.key) }})
            </button>
          </div>

          <div class="export-table">
            <vs-table stripe :data="filteredDailyData">

              <template slot="header">
                <vs-button :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
                  @click="activePromptDaily = true">Export</vs-button>
              </template>

              <template slot="thead">
                <vs-th sort-key="date">วันที่</vs-th>
                <vs-th sort-key="new_members">สมาชิกใหม่</vs-th>
                <vs-th sort-key="deposited">ฝากแล้ว</vs-th>
                <vs-th sort-key="old_customers">ลูกค้าเก่าฝากซ้ำ</vs-th>
                <vs-th sort-key="total_deposit">เติมเงิน (บาท)</vs-th>
                <vs-th sort-key="total_withdraw">ถอนเงิน (บาท)</vs-th>
                <vs-th sort-key="profit">กำไร (บาท)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td class="font-bold">{{ formatDate(data[indextr].date) }}</vs-td>
                  <vs-td>{{ data[indextr].new_members }}</vs-td>
                  <vs-td class="text-success font-bold">{{ data[indextr].deposited }}</vs-td>
                  <vs-td class="text-primary font-bold">{{ data[indextr].old_customers || 0 }}</vs-td>
                  <vs-td class="text-success font-bold">{{ formatMoney(data[indextr].total_deposit) }}</vs-td>
                  <vs-td class="text-danger font-bold">{{ formatMoney(data[indextr].total_withdraw) }}</vs-td>
                  <vs-td class="font-bold"
                    :class="Number(data[indextr].profit) >= 0 ? 'text-success' : 'text-danger'">
                    {{ formatMoney(data[indextr].profit) }}
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>

            <div v-if="filteredDailyData.length === 0" class="text-center py-4 opacity-75">
              ไม่มีวันที่ตรงกับฟิลเตอร์นี้
            </div>
          </div>
        </vx-card>

        <!-- ===================== ตารางรายละเอียด ===================== -->
        <vx-card v-if="detailData.length > 0">
          <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFieldsDetail"
            @accept="exportDetailToExcel" accept-text="Export" @close="clearFieldsDetail"
            :active.sync="activePromptDetail">
            <vs-input v-model="fileNameDetail" placeholder="Enter File Name.." class="w-full" />
            <v-select v-model="selectedFormat" :options="formats" class="my-4" />
            <div class="flex">
              <span class="mr-4">Cell Auto Width:</span>
              <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
            </div>
          </vs-prompt>

          <div class="export-table">
            <vs-table stripe pagination max-items="20" :data="detailData" search>

              <template slot="header">
                <vs-button :disabled="$store.state.AppActiveUser.permissions.report.action ? false : true"
                  @click="activePromptDetail = true">Export</vs-button>
              </template>

              <template slot="thead">
                <vs-th sort-key="member_username">Username</vs-th>
                <vs-th sort-key="member_level">สถานะ</vs-th>
                <vs-th sort-key="total_deposit">เติมเงิน (บาท)</vs-th>
                <vs-th sort-key="total_withdraw">ถอนเงิน (บาท)</vs-th>
                <vs-th>กำไร (บาท)</vs-th>
                <vs-th sort-key="latest_topup_datetime">เติมเงินล่าสุด</vs-th>
                <vs-th sort-key="member_register_date">วันที่สมัคร</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td class="text-danger font-bold">
                    <router-link :to="`/member/${data[indextr].member_username}`">
                      {{ data[indextr].member_username }}
                    </router-link>
                  </vs-td>

                  <vs-td>
                    <vs-chip :color="data[indextr].member_level == 0 ? 'danger' : 'success'">
                      {{ data[indextr].member_level == 0 ? 'ยังไม่เติมเงิน' : 'เติมเงินแล้ว' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td class="text-success font-bold">{{ formatMoneyZero(data[indextr].total_deposit) }}</vs-td>
                  <vs-td class="text-danger font-bold">{{ formatMoneyZero(data[indextr].total_withdraw) }}</vs-td>

                  <vs-td class="font-bold"
                    :class="rowProfit(data[indextr]) >= 0 ? 'text-success' : 'text-danger'">
                    {{ formatMoneyZero(rowProfit(data[indextr])) }}
                  </vs-td>

                  <vs-td>
                    <div>{{ formatDateTime(data[indextr].latest_topup_datetime) }}</div>
                    <div v-if="data[indextr].latest_topup_datetime" class="text-sm"
                      :class="topupAgoClass(data[indextr].latest_topup_datetime)">
                      {{ topupAgoText(data[indextr].latest_topup_datetime) }}
                    </div>
                  </vs-td>

                  <vs-td>{{ formatDate(data[indextr].member_register_date) }}</vs-td>
                </vs-tr>
              </template>

            </vs-table>
          </div>
        </vx-card>

      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import axios from '../../axios'
import moment from 'moment'

export default {
  components: {
    vSelect,
    flatPickr,
    StatisticsCardLine
  },
  data () {
    return {
      start_date: moment.tz('Asia/Bangkok').format('YYYY-MM-DD'),
      end_date: moment.tz('Asia/Bangkok').add(1, 'days').format('YYYY-MM-DD'),
      aff_username: '',
      isLoading: false,
      configDatePicker: {
        dateFormat: 'Y-m-d'
      },

      detailData: [],
      dailyData: [],
      dailyFilter: 'all',
      dailyFilters: [
        { key: 'all', label: 'ทั้งหมด' },
        { key: 'deposit', label: 'มีรายการฝาก' },
        { key: 'newmember', label: 'มีสมาชิกใหม่' },
        { key: 'active', label: 'มีความเคลื่อนไหว' }
      ],

      // export
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      activePromptDaily: false,
      activePromptDetail: false,
      fileNameDaily: '',
      fileNameDetail: '',
      headerTitleDaily: ['วันที่', 'สมาชิกใหม่', 'ฝากแล้ว', 'ลูกค้าเก่าฝากซ้ำ', 'เติมเงิน (บาท)', 'ถอนเงิน (บาท)', 'กำไร (บาท)'],
      headerValDaily: ['date', 'new_members', 'deposited', 'old_customers', 'total_deposit', 'total_withdraw', 'profit'],
      headerTitleDetail: ['AFF (ผู้แนะนำ)', 'Username', 'สถานะ', 'เติมเงิน (บาท)', 'ถอนเงิน (บาท)', 'กำไร (บาท)', 'เติมเงินล่าสุด', 'วันที่สมัคร']
    }
  },
  computed: {
    summary () {
      return {
        totalMembers: this.detailData.length,
        depositedMembers: this.detailData.filter(item => Number(item.member_level) === 1).length,
        totalDeposit: this.detailData.reduce((sum, item) => sum + (Number(item.total_deposit) || 0), 0),
        totalWithdraw: this.detailData.reduce((sum, item) => sum + (Number(item.total_withdraw) || 0), 0)
      }
    },
    filteredDailyData () {
      return this.dailyData.filter(row => this.matchDailyFilter(row, this.dailyFilter))
    }
  },
  methods: {
    async searchData () {
      if (!this.start_date || !this.end_date) {
        this.$vs.notify({
          title: 'แจ้งเตือน',
          text: 'กรุณาเลือกวันที่ก่อน',
          color: 'warning'
        })
        return
      }

      const aff = (this.aff_username || '').trim()
      if (!aff) {
        this.$vs.notify({
          title: 'แจ้งเตือน',
          text: 'กรุณากรอก Username AFF ก่อนค้นหา',
          color: 'warning'
        })
        return
      }

      this.isLoading = true
      this.detailData = []
      this.dailyData = []

      try {
        const [detailRes, dailyRes] = await Promise.all([
          axios.get(`reportaff/affmemberdetail/${aff}/${this.start_date}/${this.end_date}`),
          axios.get(`reportaff/affdailysummary/${aff}/${this.start_date}/${this.end_date}`)
        ])

        this.detailData = detailRes.data || []
        this.dailyData = dailyRes.data || []

        this.fileNameDetail = `Report_AffDetail_${this.start_date}_${this.end_date}`
        this.fileNameDaily = `Report_AffDaily_${this.start_date}_${this.end_date}`

        if (this.detailData.length === 0) {
          this.$vs.notify({
            title: 'ไม่พบข้อมูล',
            text: 'ไม่มีข้อมูลในช่วงวันที่ที่เลือก',
            color: 'warning'
          })
        }
      } catch (error) {
        this.$vs.notify({
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถโหลดข้อมูลได้',
          color: 'danger'
        })
      } finally {
        this.isLoading = false
      }
    },

    // ---------- ฟิลเตอร์ตารางรายวัน ----------
    matchDailyFilter (row, key) {
      const deposit = Number(row.total_deposit) || 0
      const deposited = Number(row.deposited) || 0
      const newMembers = Number(row.new_members) || 0
      const withdraw = Number(row.total_withdraw) || 0
      const oldCustomers = Number(row.old_customers) || 0

      if (key === 'deposit') return deposit > 0 || deposited > 0
      if (key === 'newmember') return newMembers > 0
      if (key === 'active') return deposit > 0 || deposited > 0 || newMembers > 0 || withdraw > 0 || oldCustomers > 0
      return true
    },
    dailyFilterCount (key) {
      return this.dailyData.filter(row => this.matchDailyFilter(row, key)).length
    },

    // ---------- formatting ----------
    formatMoney (value) {
      if (value === null || value === undefined || value === '') return '-'
      const num = Number(value)
      if (isNaN(num)) return '-'
      return num.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatMoneyZero (value) {
      const num = Number(value) || 0
      return num.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDate (value) {
      if (!value) return '-'
      return moment(value).format('DD/MM/YYYY')
    },
    formatDateTime (value) {
      if (!value) return '-'
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
    rowProfit (row) {
      return (Number(row.total_deposit) || 0) - (Number(row.total_withdraw) || 0)
    },

    // ---------- เติมเงินล่าสุด: ผ่านมาแล้ว ----------
    topupDiffHours (datetime) {
      return moment().diff(moment(datetime), 'hours', true)
    },
    topupAgoText (datetime) {
      if (!datetime) return ''
      const diffHours = this.topupDiffHours(datetime)
      if (diffHours < 24) {
        return `${Math.max(1, Math.ceil(diffHours))} ชม. ที่ผ่านมา`
      }
      return `${Math.floor(diffHours / 24)} วันที่ผ่านมา`
    },
    topupAgoClass (datetime) {
      if (!datetime) return ''
      const diffHours = this.topupDiffHours(datetime)
      if (diffHours < 24) return 'text-success'
      if (diffHours <= 168) return 'text-warning'
      return 'text-danger'
    },

    // ---------- export ----------
    exportDailyToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(this.headerValDaily, this.filteredDailyData)
        excel.export_json_to_excel({
          header: this.headerTitleDaily,
          data,
          filename: this.fileNameDaily,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFieldsDaily()
      })
    },
    exportDetailToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.detailData.map(row => [
          row.member_aff,
          row.member_username,
          Number(row.member_level) === 0 ? 'ยังไม่เติมเงิน' : 'เติมเงินแล้ว',
          Number(row.total_deposit) || 0,
          Number(row.total_withdraw) || 0,
          this.rowProfit(row),
          row.latest_topup_datetime ? moment(row.latest_topup_datetime).format('DD/MM/YYYY HH:mm:ss') : '-',
          row.member_register_date
        ])
        excel.export_json_to_excel({
          header: this.headerTitleDetail,
          data,
          filename: this.fileNameDetail,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFieldsDetail()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    clearFieldsDaily () {
      this.fileNameDaily = `Report_AffDaily_${this.start_date}_${this.end_date}`
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    clearFieldsDetail () {
      this.fileNameDetail = `Report_AffDetail_${this.start_date}_${this.end_date}`
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
}
</script>

<style scoped>
.daily-chip {
  background: transparent;
  border: 1px solid rgba(var(--vs-primary), 0.5);
  color: rgba(var(--vs-primary), 1);
  border-radius: 9999px;
  padding: 0.35rem 0.95rem;
  margin: 0 0.5rem 0.5rem 0;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;
}

.daily-chip:hover {
  background: rgba(var(--vs-primary), 0.14);
}

.daily-chip--active {
  background: rgba(var(--vs-primary), 1);
  border-color: rgba(var(--vs-primary), 1);
  color: #fff;
}
</style>
